import { Provider } from '@angular/core';
import {
    AdminGuard,
    FeatureGuard,
    ManufacturerGuard,
    NoAuthGuard,
    PrivilegesGuard,
    RetailerGuard
} from 'services/guards';
import { StudioAnneloesGuard } from 'app/b2b-order/services/guards/studio-anneloes-guard.service';
import { BrandReorderGuard } from 'app/b2b-order/services/guards/brand-reorder-guard.service';
import { PvhGuard } from 'app/content/services/guards/pvh-guard.service';
import { MustangGuard } from 'app/b2b-order/services/guards/mustang-guard.service';

export const guardProviders = [
    NoAuthGuard,
    FeatureGuard,
    AdminGuard,
    RetailerGuard,
    ManufacturerGuard,
    BrandReorderGuard,
    PrivilegesGuard,
    PvhGuard,
    MustangGuard,
    StudioAnneloesGuard
] as Provider[];
